export default {
  init() {
    const body = $('body');

    const sustainabilityCaseStudies = $('section.sustainability-case-studies');
    if (sustainabilityCaseStudies.length) {
      const slider = sustainabilityCaseStudies.find('.slick');
      if (slider.length) {
        const nav = sustainabilityCaseStudies.find('.slick-nav-wrapper');

        slider.slick({
          slidesToShow: 1.1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: false,
          prevArrow: nav.find('.prev'),
          nextArrow: nav.find('.next'),
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              },
            },
          ],
        });
      }

      const btnModalTrigger = sustainabilityCaseStudies.find('.btn-modal-trigger');
      const sustainabilityCaseStudiesModalClose = sustainabilityCaseStudies.find('.sustainability-case-studies-modal-close');

      btnModalTrigger.on('click', function() {
        const _this = $(this);
        const modalData = _this.data('modal');

        if (modalData) {
          const modal = $(modalData);
          if (modal.length) {
            body.addClass('sustainability-case-studies-modal-mode');
            modal.attr('data-visible', true);
          }
        }
      });

      sustainabilityCaseStudiesModalClose.on('click', function(e) {
        e.preventDefault();

        const _this = $(this);
        const modal = _this.closest('.sustainability-case-studies-modal');

        body.removeClass('sustainability-case-studies-modal-mode');
        modal.attr('data-visible', false);
      });
    }

    const sustainabilityEcoTourism = $('section.sustainability-eco-tourism');
    if (sustainabilityEcoTourism.length) {
      const slider = sustainabilityEcoTourism.find('.slick');
      if (slider.length) {
        const nav = sustainabilityEcoTourism.find('.slick-nav-wrapper');

        slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: false,
          prevArrow: nav.find('.prev'),
          nextArrow: nav.find('.next'),
          focusOnSelect: true,
        });
      }
    }
  },
  finalize() {
    // finalize here
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalSustainability.js